import { useMemo } from 'react'
import { logEvent } from '@mfs/client/common/log-ga-event/logGaEvent'
import { getVipTierLabelFromLocalStorage } from '../../../util/vipTierLevelFromLocalStorage'

const logPkgFlyListingVipBadgeDisplay = () => {
  logEvent('display', {
    type: 'vip_badge_on_card',
    item_name: 'signed_in',
    page_name: 'pkg_fly_listings',
    product_name: 'bundle',
  })
}

/**
 * Package fly listings: VIP tier from localStorage and GA4 callback for Horizon card badge.
 */
export function usePkgFlyListingVipBadge({
  isPackageListings,
  isPricelineOnly,
  isUserLoggedIn,
  isHorizonListing,
}) {
  const loyaltyTier =
    isPricelineOnly && isPackageListings && isUserLoggedIn ? getVipTierLabelFromLocalStorage() : ''

  const vipTierBadge = useMemo(() => {
    if (!isHorizonListing || !loyaltyTier) return undefined
    return { loyaltyTier, onVipTierBadgeDisplay: logPkgFlyListingVipBadgeDisplay }
  }, [isHorizonListing, loyaltyTier])

  return {
    getVipTierBadgeForItinerary: (itinerary) => {
      if (!vipTierBadge || !itinerary?.pricingMerchandisings?.some((m) => m?.key === 'VIP_ONLY')) {
        return undefined
      }
      return vipTierBadge
    },
  }
}
